var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("personalizedDesignsController", [
    "$scope",
    "$rootScope",
    "$timeout",
    "cartService",
    "accountService",
    "storefrontApp.mainContext",
    function (
        $scope,
        $rootScope,
        $timeout,
        cartService,
        accountService,
        storefrontAppMainContext
    ) {
        function parsePipeList(v) {
            return typeof v === "string" ? v.split("|") : v || [];
        }
        function parseMultiDelimiterList(value) {
            if (typeof value !== "string" || !value.length) {
                return [];
            }
            return value.split(/[,|]/).map(function (x) {
                return x.trim();
            }).filter(function (x) {
                return x.length;
            });
        }

        //#region Resize
        $scope.activeTab = "resize";
        $scope.validationMessage = "";
        $scope.product = {
            name: window.products[0].name,
            brand: window.products[0].brand,
            definitionName: window.products[0].definitionName,
            imageUrl: (function () {
                var def = window.products[0].definitionName.toLowerCase();
                var brand = window.products[0].catalogId
                    .replace(/\s+/g, "_")
                    .toLowerCase();
                var itemIdParts = window.products[0].id.split("-");
                var itemId =
                    itemIdParts.length > 1 ? itemIdParts[1] : itemIdParts[0];
                return (
                    window.__env.imageUrl +
                    def +
                    "/xlarge/" +
                    brand +
                    "/" +
                    itemId +
                    ".webp"
                );
            })(),
            fta: parseMultiDelimiterList(window.products[0].fileTypes).map(
                function (x) {
                    return x.trim().toUpperCase();
                }
            ),
            variantDimensions: parsePipeList(
                window.products[0].variantDimensions
            ),
            variantIds: parsePipeList(window.products[0].variantIds),
            variantPrices: parsePipeList(window.products[0].variantPrices),
        };
        function letteringEligibleFromCurrentFileTypesString() {
            var raw =
                window.products[0] &&
                typeof window.products[0].fileTypes === "string"
                    ? window.products[0].fileTypes
                    : "";
            var l = raw.toLowerCase();
            if (!l || l.indexOf("embrilliance") !== -1) {
                return false;
            }
            return l.indexOf("emb") !== -1;
        }
        var wp = window.products && window.products[0];
        var defNorm = ($scope.product.definitionName || "").toLowerCase().replace(/[\s\-_]/g, "");
        var pdpUrlPathLower = (window.location.pathname || "").toLowerCase();
        var isFontLetterByUrl = pdpUrlPathLower.indexOf("/fontletter/") > -1;
        if (isFontLetterByUrl && defNorm !== "fontletter") {
            defNorm = "fontletter";
        }
        $scope.isFontLetterProduct = defNorm === "fontletter";
        $scope.isLetteringEligible =
            defNorm === "fontletter" ||
            (defNorm === "stockdesign" &&
            !!wp &&
            (Object.prototype.hasOwnProperty.call(wp, "letteringEmbEligible")
                ? wp.letteringEmbEligible === true
                : letteringEligibleFromCurrentFileTypesString()));
        $scope.resize = {
            PDWidth: "",
            PDHeight: "",
            unit: "inches",
            PDIsProportionalHeight: false,
            PDIsProportionalWidth: false,
            PDIsCap: false,
            PDOrigItemId: "",
            PDOrigCatalog: "",
            PDOrigDefinitionName: "",
            PDOrderStatus: "",
            PDType: "",
            PDName: "",
        };
        $scope.price = {
            regular: 0,
            circle: 0,
        };
        $scope.circleDiscount = window.__env.personalizeCircleDiscount;
        $scope.capResizePrice = window.__env.personalizeCapResizePrice;
        $scope.resizeCta = {
            text: "ADD TO CART",
            style: "",
        };
        $scope.letteringCta = {
            add: {
                text: "ADD TO CART",
                style: "",
            },
            replace: {
                text: "ADD TO CART",
                style: "",
            },
        };
        $scope.getLetteringButtonText = function () {
            return $scope.letteringMode.value === "replace"
                ? $scope.letteringCta.replace.text
                : $scope.letteringCta.add.text;
        };
        $scope.getLetteringButtonStyle = function () {
            return $scope.letteringMode.value === "replace"
                ? $scope.letteringCta.replace.style
                : $scope.letteringCta.add.style;
        };
        $scope.isCircleMember = false;
        $scope.isCircleMemberActive = false;
        $scope.membership = null;
        $scope.customer = null;
        $scope.setActiveTab = function (tab) {
            $scope.activeTab = tab;
        };
        var deregisterPersonalizedTab = $rootScope.$on(
            "personalizedDesigns:setActiveTab",
            function (event, tab) {
                if (
                    tab === "resize" ||
                    tab === "lettering" ||
                    tab === "ai"
                ) {
                    $scope.activeTab = tab;
                }
            }
        );
        $scope.$on("$destroy", deregisterPersonalizedTab);

        //#endregion
        //#region Add Lettering
        var letteringDims = $scope.product.variantDimensions || [];
        var letteringIds = $scope.product.variantIds || [];
        var letteringPrices = $scope.product.variantPrices || [];
        $scope.sizeOptions = [];
        for (var d = 0; d < letteringDims.length; d++) {
            var dimStr = letteringDims[d];
            var dimParts = (dimStr || "").split(",");
            var dimW = dimParts[0] ? parseFloat(dimParts[0], 10) : 0;
            var dimH = dimParts[1] ? parseFloat(dimParts[1], 10) : 0;
            var dimLabel =
                isNaN(dimW) || isNaN(dimH)
                    ? dimStr
                    : dimW + '" W x ' + dimH + '" H';
            var variantId =
                letteringIds[d] !== undefined ? letteringIds[d] : "";
            var price =
                letteringPrices[d] !== undefined
                    ? parseFloat(letteringPrices[d], 10)
                    : 0;
            if (isNaN(price)) price = 0;
            $scope.sizeOptions.push({
                label: dimLabel,
                variantId: variantId,
                price: price,
                width: dimW,
                height: dimH,
                // Stable key for ng-options track by (variantId can repeat or be empty)
                trackKey: "sz-" + d + "-" + String(variantId || ""),
            });
        }
        $scope.letteringPriceFromApi = null;

        $scope.placements = [
            "Above",
            "Below",
            "Upper Arc",
            "Lower Arc",
            "Best Placement (Designer's choice)",
        ];
        /** Object + .value so ng-model inside ng-if does not shadow a primitive on the parent scope. */
        $scope.letteringMode = { value: "add" };
        $scope.letteringTextAreas = [
            {
                id: "lettering-ta-1",
                placement: "Best Placement (Designer's choice)",
                text: "",
                font: "Block",
                threadColor: "Navy",
                textSize: "Medium",
                alignment: "Center",
            },
        ];
        $scope.letteringReplacements = [
            { id: "lettering-rep-1", originalText: "", replacementText: "" },
        ];
        $scope.letteringNotes = {
            add: "",
            replace: "",
        };
        /**
         * Lettering state on a single object so ng-model inside ng-if does not shadow
         * the parent scope (see letteringMode.value).
         */
        $scope.lettering = {
            selectedSize:
                $scope.sizeOptions.length > 0 ? $scope.sizeOptions[0] : null,
            PDWidth: "",
            PDHeight: "",
        };

        $scope.setLetteringMode = function (mode) {
            $scope.letteringMode.value = mode;
        };

        var letteringPricingDebounce;
        $scope.updateLetteringTextArea = function (id, field, value) {
            var areas = $scope.letteringTextAreas;
            for (var i = 0; i < areas.length; i++) {
                if (areas[i].id === id) {
                    areas[i][field] = value;
                    break;
                }
            }
            if (field === "text" && (value || "").toString().trim() !== "") {
                $scope.letteringReplacements.forEach(function (r) {
                    r.originalText = "";
                    r.replacementText = "";
                });
            }
            if (
                field === "text" &&
                $scope.activeTab === "lettering" &&
                $scope.letteringMode.value === "add"
            ) {
                if (letteringPricingDebounce)
                    $timeout.cancel(letteringPricingDebounce);
                letteringPricingDebounce = $timeout(function () {
                    letteringPricingDebounce = null;
                    updateLetteringPricing();
                }, 400);
            }
        };

        $scope.addLetteringReplacement = function () {
            if ($scope.letteringReplacements.length >= 2) return;
            $scope.letteringReplacements.push({
                id: "lettering-rep-" + Date.now(),
                originalText: "",
                replacementText: "",
            });
        };

        $scope.updateLetteringReplacement = function (id, field, value) {
            var reps = $scope.letteringReplacements;
            for (var i = 0; i < reps.length; i++) {
                if (reps[i].id === id) {
                    reps[i][field] = value;
                    break;
                }
            }
            if (
                (field === "originalText" || field === "replacementText") &&
                (value || "").toString().trim() !== ""
            ) {
                ($scope.letteringTextAreas || []).forEach(function (a) {
                    a.text = "";
                });
            }
            if (
                (field === "originalText" || field === "replacementText") &&
                $scope.activeTab === "lettering" &&
                $scope.letteringMode.value === "replace"
            ) {
                if (letteringPricingDebounce)
                    $timeout.cancel(letteringPricingDebounce);
                letteringPricingDebounce = $timeout(function () {
                    letteringPricingDebounce = null;
                    updateLetteringPricing();
                }, 400);
            }
        };

        $scope.removeLetteringReplacement = function (id) {
            if ($scope.letteringReplacements.length <= 1) return;
            $scope.letteringReplacements = $scope.letteringReplacements.filter(
                function (r) {
                    return r.id !== id;
                }
            );
        };

        $scope.getLetteringValidTextAreas = function () {
            return ($scope.letteringTextAreas || []).filter(function (t) {
                return t.text && t.text.trim() !== "";
            });
        };

        $scope.getLetteringValidReplacements = function () {
            return ($scope.letteringReplacements || []).filter(function (r) {
                return (
                    r.originalText &&
                    r.originalText.trim() !== "" &&
                    r.replacementText &&
                    r.replacementText.trim() !== ""
                );
            });
        };

        /**
         * Replace mode: first pair must be complete. Extra rows count only if the user
         * entered something in that row (fully empty second row = optional one-pair flow).
         */
        function isLetteringReplaceFormComplete() {
            var reps = $scope.letteringReplacements || [];
            if (!reps.length) {
                return false;
            }
            function pairTrimmed(r) {
                return {
                    o: (r.originalText || "").trim(),
                    n: (r.replacementText || "").trim(),
                };
            }
            var first = pairTrimmed(reps[0]);
            if (first.o === "" || first.n === "") {
                return false;
            }
            for (var i = 1; i < reps.length; i++) {
                var p = pairTrimmed(reps[i]);
                if (p.o === "" && p.n === "") {
                    continue;
                }
                if (p.o === "" || p.n === "") {
                    return false;
                }
            }
            return true;
        }

        $scope.getLetteringSelectedSize = function () {
            var opts = $scope.sizeOptions || [];
            var sel =
                $scope.lettering && $scope.lettering.selectedSize
                    ? $scope.lettering.selectedSize
                    : null;
            if (sel && opts.length) {
                for (var i = 0; i < opts.length; i++) {
                    if (
                        opts[i] === sel ||
                        (sel.trackKey != null &&
                            opts[i].trackKey === sel.trackKey)
                    ) {
                        return opts[i];
                    }
                }
            }
            return (
                opts[0] || {
                    label: "",
                    variantId: "",
                    price: 0,
                    width: 0,
                    height: 0,
                }
            );
        };

        function syncLetteringDimensionsFromSelectedSize() {
            var size = $scope.getLetteringSelectedSize();
            var w =
                size && size.width !== undefined && !isNaN(size.width)
                    ? Number(size.width)
                    : 0;
            var h =
                size && size.height !== undefined && !isNaN(size.height)
                    ? Number(size.height)
                    : 0;
            $scope.lettering.PDWidth = w > 0 ? w.toFixed(2) : "0.00";
            $scope.lettering.PDHeight = h > 0 ? h.toFixed(2) : "0.00";
        }

        /** Keep model pointing at a canonical row in sizeOptions (fixes summary + ng-options edge cases). */
        function normalizeLetteringSelectedSize() {
            var opts = $scope.sizeOptions || [];
            if (!$scope.lettering) {
                $scope.lettering = {
                    selectedSize: null,
                    PDWidth: "",
                    PDHeight: "",
                };
            }
            if (!opts.length) {
                $scope.lettering.selectedSize = null;
                syncLetteringDimensionsFromSelectedSize();
                return;
            }
            var sel = $scope.lettering.selectedSize;
            if (sel == null) {
                $scope.lettering.selectedSize = opts[0];
            } else if (typeof sel === "number" || typeof sel === "string") {
                var idx = parseInt(String(sel), 10);
                if (!isNaN(idx) && idx >= 0 && idx < opts.length) {
                    $scope.lettering.selectedSize = opts[idx];
                } else {
                    $scope.lettering.selectedSize = opts[0];
                }
            } else {
                var matched = false;
                for (var i = 0; i < opts.length; i++) {
                    if (opts[i] === sel) {
                        matched = true;
                        break;
                    }
                    if (
                        sel.trackKey != null &&
                        opts[i].trackKey === sel.trackKey
                    ) {
                        $scope.lettering.selectedSize = opts[i];
                        matched = true;
                        break;
                    }
                }
                if (!matched) {
                    $scope.lettering.selectedSize = opts[0];
                }
            }
            syncLetteringDimensionsFromSelectedSize();
        }

        normalizeLetteringSelectedSize();

        $scope.getLetteringTotalItems = function () {
            return (
                $scope.getLetteringValidTextAreas().length +
                $scope.getLetteringValidReplacements().length
            );
        };

        $scope.isLetteringFormValid = function () {
            if ($scope.letteringMode.value === "replace") {
                return isLetteringReplaceFormComplete();
            }
            return $scope.getLetteringValidTextAreas().length > 0;
        };

        $scope.getLetteringTotal = function () {
            if (
                $scope.letteringPriceFromApi !== null &&
                $scope.letteringPriceFromApi !== undefined
            ) {
                return parseFloat($scope.letteringPriceFromApi, 10);
            }
            return 0;
        };

        $scope.getLetteringCirclePrice = function () {
            var total = $scope.getLetteringTotal();
            var discount =
                $scope.circleDiscount !== undefined &&
                $scope.circleDiscount !== null
                    ? $scope.circleDiscount / 100
                    : 0.1;
            return total * (1 - discount);
        };

        function buildLetteringPricePayload() {
            normalizeLetteringSelectedSize();
            var size = $scope.getLetteringSelectedSize();
            var mode =
                $scope.letteringMode && $scope.letteringMode.value
                    ? $scope.letteringMode.value
                    : "add";
            var PDWidth = parseFloat($scope.lettering.PDWidth, 10);
            var PDHeight = parseFloat($scope.lettering.PDHeight, 10);
            if (isNaN(PDWidth)) {
                PDWidth = 0;
            }
            if (isNaN(PDHeight)) {
                PDHeight = 0;
            }
            var DesignPrice = size && size.price !== undefined ? size.price : 0;
            var addTexts = ($scope.letteringTextAreas || [])
                .map(function (a) {
                    return (a.text || "").trim();
                })
                .filter(function (t) {
                    return t.length > 0;
                });
            if (mode === "replace") {
                addTexts = [];
            }
            var PDAddText = addTexts.join(", ") || "";
            var reps = $scope.letteringReplacements || [];
            var PDReplaceText1 = reps[0]
                ? (reps[0].originalText || "").trim()
                : "";
            var PDNewText1 = reps[0]
                ? (reps[0].replacementText || "").trim()
                : "";
            var PDReplaceText2 = reps[1]
                ? (reps[1].originalText || "").trim()
                : "";
            var PDNewText2 = reps[1]
                ? (reps[1].replacementText || "").trim()
                : "";
            if (mode === "add") {
                PDReplaceText1 = "";
                PDNewText1 = "";
                PDReplaceText2 = "";
                PDNewText2 = "";
            }
            var PDHoopSize = size && size.label ? size.label : "";
            var areas = $scope.letteringTextAreas || [];
            var PDTextPlacement =
                mode === "add" && areas[0] && areas[0].placement
                    ? areas[0].placement
                    : "";
            return {
                RequestType: "addlettering",
                PDType: "lettering",
                PDWidth: PDWidth,
                PDHeight: PDHeight,
                PDAddText: PDAddText,
                PDReplaceText1: PDReplaceText1,
                PDNewText1: PDNewText1,
                PDReplaceText2: PDReplaceText2,
                PDNewText2: PDNewText2,
                DesignPrice: DesignPrice,
                PDHoopSize: PDHoopSize,
                PDTextPlacement: PDTextPlacement,
            };
        }

        $scope.onLetteringSizeChange = function () {
            normalizeLetteringSelectedSize();
            if ($scope.activeTab === "lettering") {
                updateLetteringPricing();
            }
        };

        function updateLetteringPricing() {
            if ($scope.activeTab !== "lettering" || !$scope.isLetteringEligible)
                return;
            var payload = buildLetteringPricePayload();
            cartService
                .fetchPersonalizedDesignPrice(payload)
                .then(function (response) {
                    if (
                        response &&
                        response.data !== undefined &&
                        response.data !== null
                    ) {
                        $scope.letteringPriceFromApi = parseFloat(
                            response.data,
                            10
                        );
                        if (isNaN($scope.letteringPriceFromApi))
                            $scope.letteringPriceFromApi = null;
                    } else {
                        $scope.letteringPriceFromApi = null;
                    }
                })
                .catch(function (error) {
                    console.error("Error fetching lettering price:", error);
                    $scope.letteringPriceFromApi = null;
                });
        }

        $scope.addLetteringToCart = function () {
            var isReplaceMode = $scope.letteringMode.value === "replace";
            var currentCta = isReplaceMode
                ? $scope.letteringCta.replace
                : $scope.letteringCta.add;
            if (currentCta.text === "PROCEED TO CHECKOUT") {
                window.location.href = "/cart";
                return;
            }
            if (!$scope.isLetteringFormValid()) {
                return;
            }
            $rootScope.showLoader = true;
            var base = buildLetteringPricePayload();
            var payload = {
                RequestType: base.RequestType,
                PDType: base.PDType,
                PDWidth: $scope.lettering.PDWidth,
                PDHeight: $scope.lettering.PDHeight,
                PDAddText: base.PDAddText,
                PDReplaceText1: base.PDReplaceText1,
                PDNewText1: base.PDNewText1,
                PDReplaceText2: base.PDReplaceText2,
                PDNewText2: base.PDNewText2,
                DesignPrice: base.DesignPrice,
                PDHoopSize: base.PDHoopSize,
                PDTextPlacement: base.PDTextPlacement,
                PDName: $scope.product.name + " - Personalized Lettering",
                PDOrigItemId: window.products[0].id,
                PDOrigCatalog: window.products[0].catalogId,
                PDOrigDefinitionName: $scope.isFontLetterProduct
                    ? "FontLetter"
                    : window.products[0].definitionName,
                PDAddTextNotes: ($scope.letteringNotes && $scope.letteringNotes.add) || "",
                PDReplaceTextNotes:
                    ($scope.letteringNotes && $scope.letteringNotes.replace) || "",
            };
            cartService
                .addPersonalizedDesignToCart(payload)
                .then(function (response) {
                    $rootScope.showLoader = false;
                    if (
                        response &&
                        response.data &&
                        response.data.itemAdded === true
                    ) {
                        currentCta.text = "PROCEED TO CHECKOUT";
                        currentCta.style = "checkout-style";
                    }
                })
                .catch(function (error) {
                    $rootScope.showLoader = false;
                    console.error("Error adding lettering to cart:", error);
                });
        };

        //#endregion
        //#region Resize
        function getClubMembershipInfo() {
            if ($scope.customer && $scope.customer.contactId) {
                accountService
                    .getCustomerMembershipDetails($scope.customer.contactId)
                    .then(function (response) {
                        if (response && response.data) {
                            $scope.membership = response.data;
                            $scope.isCircleMember = true;
                            $scope.isCircleMemberActive =
                                $scope.membership.isActive;
                        } else {
                            $scope.isCircleMember = false;
                        }
                    })
                    .catch(function (error) {
                        console.error(
                            "Error fetching membership details:",
                            error
                        );
                        $scope.isCircleMember = false;
                    });
            } else {
                $scope.isCircleMember = false;
            }
        }
        $scope.onDimensionChange = function () {
            validateDimensions();
            updatePricing();
        };
        $scope.onUnitChange = function () {
            $rootScope.showLoader = true;
            $scope.resize.PDWidth = "";
            $scope.resize.PDHeight = "";
            $scope.resize.PDIsProportionalHeight = false;
            $scope.resize.PDIsProportionalWidth = false;
            $scope.resize.PDIsCap = false;
            validateDimensions();
            updatePricing();
            $rootScope.showLoader = false;
        };
        $scope.onProportionalChange = function () {
            $rootScope.showLoader = true;
            if ($scope.resize.PDIsProportionalHeight) {
                $scope.resize.PDIsCap = false;
                $scope.resize.PDIsProportionalWidth = false;
                $scope.resize.PDHeight = "";
                if ($scope.resize.PDWidth === "Cap Optimized Size") {
                    $scope.resize.PDWidth = "";
                }
            }
            validateDimensions();
            updatePricing();
            $rootScope.showLoader = false;
        };
        $scope.onProportionalWidthChange = function () {
            $rootScope.showLoader = true;
            if ($scope.resize.PDIsProportionalWidth) {
                $scope.resize.PDIsCap = false;
                $scope.resize.PDIsProportionalHeight = false;
                $scope.resize.PDWidth = "";
                if ($scope.resize.PDHeight === "Cap Optimized Size") {
                    $scope.resize.PDHeight = "";
                }
            }
            validateDimensions();
            updatePricing();
            $rootScope.showLoader = false;
        };
        $scope.onCapSizeChange = function () {
            $rootScope.showLoader = true;
            if ($scope.resize.PDIsCap) {
                $scope.resize.PDIsProportionalHeight = false;
                $scope.resize.PDIsProportionalWidth = false;
                $scope.resize.PDWidth = "Cap Optimized Size";
                $scope.resize.PDHeight = "Cap Optimized Size";
            } else {
                $scope.resize.PDWidth = "";
                $scope.resize.PDHeight = "";
            }
            validateDimensions();
            updatePricing();
            $rootScope.showLoader = false;
        };
        function validateDimensions() {
            $scope.validationMessage = "";
            if ($scope.resize.PDIsCap) {
                return true;
            }
            var hasValidDimensions =
                ($scope.resize.PDWidth &&
                    $scope.resize.PDWidth !== "" &&
                    parseFloat($scope.resize.PDWidth) > 0) ||
                ($scope.resize.PDHeight &&
                    $scope.resize.PDHeight !== "" &&
                    parseFloat($scope.resize.PDHeight) > 0);
            var hasOptionsSelected =
                $scope.resize.PDIsProportionalHeight ||
                $scope.resize.PDIsProportionalWidth ||
                $scope.resize.PDIsCap;

            if (!hasValidDimensions && !hasOptionsSelected) {
                return true;
            }
            var widthInInches = convertToInches(
                $scope.resize.PDWidth,
                $scope.resize.unit
            );
            var heightInInches = convertToInches(
                $scope.resize.PDHeight,
                $scope.resize.unit
            );
            var minWidth = convertFromInches(1, $scope.resize.unit);
            var maxWidth = convertFromInches(12, $scope.resize.unit);
            var maxHeight = convertFromInches(16, $scope.resize.unit);
            if (
                !$scope.resize.PDIsProportionalWidth &&
                !$scope.resize.PDIsCap &&
                $scope.resize.PDWidth &&
                $scope.resize.PDWidth !== "" &&
                (widthInInches < 1 || widthInInches > 12)
            ) {
                $scope.validationMessage =
                    "Width must be between " +
                    minWidth +
                    " and " +
                    maxWidth +
                    " " +
                    $scope.resize.unit +
                    ".";
                return false;
            }
            if (
                !$scope.resize.PDIsProportionalHeight &&
                !$scope.resize.PDIsCap &&
                $scope.resize.PDHeight &&
                $scope.resize.PDHeight !== ""
            ) {
                if (heightInInches > 16) {
                    $scope.validationMessage =
                        "Height must be less than " +
                        maxHeight +
                        " " +
                        $scope.resize.unit +
                        ".";
                    return false;
                }
            }
            var userWidthRounded = Math.round(widthInInches * 100) / 100;
            var userHeightRounded = Math.round(heightInInches * 100) / 100;
            if ($scope.product.definitionName.toLowerCase() === "font") {
                if (heightInInches > 0) {
                    for (
                        var i = 0;
                        i < $scope.product.variantDimensions.length;
                        i++
                    ) {
                        var variantDim = $scope.product.variantDimensions[i];
                        if (variantDim && variantDim.trim() !== "") {
                            var dimensions = variantDim.split(",");
                            if (dimensions.length === 2) {
                                var variantWidth = parseFloat(dimensions[0]);
                                var variantHeight = parseFloat(dimensions[1]);
                                var variantWidthRounded =
                                    Math.round(variantWidth * 100) / 100;
                                var variantHeightRounded =
                                    Math.round(variantHeight * 100) / 100;
                                if (
                                    userHeightRounded === variantWidthRounded ||
                                    userHeightRounded === variantHeightRounded
                                ) {
                                    $scope.validationMessage =
                                        "Size already exists.";
                                    return false;
                                }
                            }
                        }
                    }
                }
            } else {
                if (widthInInches > 0 && heightInInches > 0) {
                    for (
                        var i = 0;
                        i < $scope.product.variantDimensions.length;
                        i++
                    ) {
                        var variantDim = $scope.product.variantDimensions[i];
                        if (variantDim && variantDim.trim() !== "") {
                            var dimensions = variantDim.split(",");
                            if (dimensions.length === 2) {
                                var variantWidth = parseFloat(dimensions[0]);
                                var variantHeight = parseFloat(dimensions[1]);
                                var variantWidthRounded =
                                    Math.round(variantWidth * 100) / 100;
                                var variantHeightRounded =
                                    Math.round(variantHeight * 100) / 100;
                                if (
                                    (userWidthRounded === variantWidthRounded &&
                                        userHeightRounded ===
                                            variantHeightRounded) ||
                                    (userWidthRounded ===
                                        variantHeightRounded &&
                                        userHeightRounded ===
                                            variantWidthRounded)
                                ) {
                                    $scope.validationMessage =
                                        "Size already exists.";
                                    return false;
                                }
                            }
                        }
                    }
                }
            }

            return true;
        }
        function updatePricing() {
            var width = $scope.resize.PDWidth;
            var height = $scope.resize.PDHeight;
            var hasValidDimensions =
                (width && width !== "" && parseFloat(width) > 0) ||
                (height && height !== "" && parseFloat(height) > 0);
            var hasOptionsSelected =
                $scope.resize.PDIsProportionalHeight ||
                $scope.resize.PDIsProportionalWidth ||
                $scope.resize.PDIsCap;

            if (!hasValidDimensions && !hasOptionsSelected) {
                $scope.price.regular = 0;
                $scope.price.circle = 0;
                return;
            }
            if (!$scope.isFormValid()) {
                $scope.price.regular = 0;
                $scope.price.circle = 0;
                return;
            }
            var widthInInches = convertToInches(
                $scope.resize.PDWidth,
                $scope.resize.unit
            );
            var heightInInches = convertToInches(
                $scope.resize.PDHeight,
                $scope.resize.unit
            );
            if ($scope.resize.PDIsProportionalHeight) {
                if (isNaN(widthInInches) || widthInInches <= 0) {
                    $scope.price.regular = 0;
                    $scope.price.circle = 0;
                    return;
                }
            }
            if ($scope.resize.PDIsProportionalWidth) {
                if (isNaN(heightInInches) || heightInInches <= 0) {
                    $scope.price.regular = 0;
                    $scope.price.circle = 0;
                    return;
                }
            }
            $scope.resize.PDOrigItemId = window.products[0].id;
            $scope.resize.PDOrigCatalog = window.products[0].catalogId;
            $scope.resize.PDOrigDefinitionName = $scope.isFontLetterProduct
                ? "FontLetter"
                : window.products[0].definitionName;
            $scope.resize.PDType = "resize";
            $scope.resize.PDName = $scope.product.name + " - Custom Size";
            var resizeForApi = angular.copy($scope.resize);
            resizeForApi.PDWidth = widthInInches.toFixed(2);
            resizeForApi.PDHeight = heightInInches.toFixed(2);
            cartService
                .fetchPersonalizedDesignPrice(resizeForApi)
                .then(function (response) {
                    if (response && response.data) {
                        $scope.price.regular = parseFloat(response.data || 0);
                        $scope.price.circle = parseFloat(
                            (
                                response.data *
                                (1 - $scope.circleDiscount / 100)
                            ).toFixed(2)
                        );
                    } else {
                        $scope.price.regular = parseFloat(
                            $scope.capResizePrice || 0
                        );
                        $scope.price.circle = parseFloat(
                            (
                                $scope.capResizePrice *
                                (1 - $scope.circleDiscount / 100)
                            ).toFixed(2)
                        );
                    }
                })
                .catch(function (error) {
                    console.error(
                        "Error fetching personalized design price:",
                        error
                    );
                    $scope.price.regular = parseFloat(
                        $scope.capResizePrice || 0
                    );
                    $scope.price.circle = parseFloat(
                        (
                            $scope.capResizePrice *
                            (1 - $scope.circleDiscount / 100)
                        ).toFixed(2)
                    );
                });
        }
        $scope.isFormValid = function () {
            if ($scope.validationMessage) {
                return false;
            }
            if ($scope.resize.PDIsCap) {
                return true;
            }
            var widthInInches = convertToInches(
                $scope.resize.PDWidth,
                $scope.resize.unit
            );
            var heightInInches = convertToInches(
                $scope.resize.PDHeight,
                $scope.resize.unit
            );
            if ($scope.product.definitionName.toLowerCase() === "font") {
                return (
                    !isNaN(heightInInches) &&
                    heightInInches > 0 &&
                    heightInInches <= 16
                );
            }
            if ($scope.resize.PDIsProportionalHeight) {
                return widthInInches >= 1 && widthInInches <= 12;
            }
            if ($scope.resize.PDIsProportionalWidth) {
                return heightInInches >= 1 && heightInInches <= 16;
            }
            if (
                isNaN(widthInInches) ||
                widthInInches < 1 ||
                widthInInches > 12
            ) {
                return false;
            }

            if (
                isNaN(heightInInches) ||
                heightInInches <= 0 ||
                heightInInches > 16
            ) {
                return false;
            }

            return true;
        };
        function convertToInches(value, unit) {
            if (!value || isNaN(parseFloat(value))) {
                return 0;
            }

            var numValue = parseFloat(value);
            var result;

            switch (unit) {
                case "inches":
                    result = numValue;
                    break;
                case "cm":
                    result = numValue / 2.54;
                    break;
                case "mm":
                    result = numValue / 25.4;
                    break;
                default:
                    result = numValue;
                    break;
            }
            return Math.round(result * 100) / 100;
        }
        function convertFromInches(valueInInches, unit) {
            if (!valueInInches || isNaN(parseFloat(valueInInches))) {
                return 0;
            }

            var numValue = parseFloat(valueInInches);
            var result;

            switch (unit) {
                case "inches":
                    result = numValue;
                    break;
                case "cm":
                    result = numValue * 2.54;
                    break;
                case "mm":
                    result = numValue * 25.4;
                    break;
                default:
                    result = numValue;
                    break;
            }
            return Math.round(result * 100) / 100;
        }
        $scope.addToCart = function () {
            if ($scope.resizeCta.text === "PROCEED TO CHECKOUT") {
                window.location.href = "/cart";
                return;
            }

            $rootScope.showLoader = true;
            if (!$scope.isFormValid()) {
                $rootScope.showLoader = false;
                return;
            }
            var widthInInches = convertToInches(
                $scope.resize.PDWidth,
                $scope.resize.unit
            );
            var heightInInches = convertToInches(
                $scope.resize.PDHeight,
                $scope.resize.unit
            );
            var resizeForApi = angular.copy($scope.resize);
            resizeForApi.PDWidth = widthInInches.toFixed(2);
            resizeForApi.PDHeight = heightInInches.toFixed(2);
            resizeForApi.PDOrigItemId = window.products[0].id;
            resizeForApi.PDOrigCatalog = window.products[0].catalogId;
            resizeForApi.PDOrigDefinitionName = $scope.isFontLetterProduct
                ? "FontLetter"
                : window.products[0].definitionName;
            resizeForApi.PDType = "resize";
            resizeForApi.PDName = $scope.product.name + " - Custom Size";
            cartService
                .addPersonalizedDesignToCart(resizeForApi)
                .then(function (response) {
                    $rootScope.showLoader = false;
                    if (
                        response &&
                        response.data &&
                        response.data.itemAdded === true
                    ) {
                        $scope.resizeCta.text = "PROCEED TO CHECKOUT";
                        $scope.resizeCta.style = "checkout-style";
                    }
                })
                .catch(function (error) {
                    $rootScope.showLoader = false;
                    console.error(
                        "Error adding personalized design to cart:",
                        error
                    );
                });
        };
        $scope.clearValidationMessage = function () {
            $scope.validationMessage = "";
        };

        //#endregion
        //#region Modal & Initialization
        $scope.togglePersonalizedDesignsModal = function (status) {
            if ($scope.$parent && $scope.$parent.toggleModal) {
                $scope.$parent.toggleModal(
                    "showPersonalizedDesignsModal",
                    status
                );
            } else if (
                $scope.$parent &&
                typeof $scope.$parent.showPersonalizedDesignsModal !==
                    "undefined"
            ) {
                $scope.$parent.showPersonalizedDesignsModal = status;
            }

            if (status) {
                $scope.price.regular = 0;
                $scope.price.circle = 0;
                $scope.letteringPriceFromApi = null;
                setTimeout(function () {
                    if ($scope.calculateOptimalModalHeight) {
                        $scope.calculateOptimalModalHeight();
                    }
                }, 200);
            }
        };
        $scope.$watch(
            function () {
                return storefrontAppMainContext.customer;
            },
            function (newCustomer) {
                if (newCustomer) {
                    $scope.customer = newCustomer;
                    getClubMembershipInfo();
                }
            }
        );
        $scope.$on("$viewContentLoaded", function () {
            $scope.resize.PDWidth = "";
            $scope.resize.PDHeight = "";
            $scope.resize.unit = "inches";
            $scope.resize.PDIsProportionalHeight = false;
            $scope.resize.PDIsProportionalWidth = false;
            $scope.resize.PDIsCap = false;
            $scope.price.regular = 0.0;
            $scope.price.circle = 0.0;
            $scope.customer = storefrontAppMainContext.customer;
            if ($scope.customer) {
                getClubMembershipInfo();
            }

            var fixedModalHeightPx = null;
            $scope.calculateOptimalModalHeight = function (forceRecompute) {
                setTimeout(function () {
                    var modalBody = document.querySelector(
                        ".personalized-designs-modal-body"
                    );
                    var modalContent = document.querySelector(".modal-content");
                    var header = document.querySelector(".modal-header");
                    var tabs = document.querySelector(".modal-tabs");
                    if (!modalBody || !modalContent || !header || !tabs) {
                        return;
                    }
                    var headerHeight = header.offsetHeight;
                    var tabsHeight = tabs.offsetHeight;
                    var windowHeight = window.innerHeight;
                    if (forceRecompute || fixedModalHeightPx === null) {
                        var targetHeight;
                        if (window.innerWidth >= 1200) {
                            targetHeight = 760;
                        } else if (window.innerWidth >= 992) {
                            targetHeight = 720;
                        } else if (window.innerWidth >= 768) {
                            targetHeight = 680;
                        } else {
                            targetHeight = windowHeight - 20;
                        }
                        var maxHeight;
                        if (windowHeight < 900) {
                            maxHeight = windowHeight * 0.95;
                        } else if (windowHeight < 1100) {
                            maxHeight = windowHeight * 0.9;
                        } else if (windowHeight < 1300) {
                            maxHeight = windowHeight * 0.85;
                        } else {
                            maxHeight = windowHeight * 0.8;
                        }
                        fixedModalHeightPx = Math.min(
                            targetHeight,
                            maxHeight,
                            windowHeight - 40
                        );
                    }
                    var finalHeight = fixedModalHeightPx;
                    var contentHeightPx =
                        finalHeight - headerHeight - tabsHeight + "px";
                    modalContent.style.setProperty(
                        "height",
                        contentHeightPx,
                        "important"
                    );
                    modalContent.style.setProperty(
                        "max-height",
                        contentHeightPx,
                        "important"
                    );
                    modalContent.style.setProperty(
                        "min-height",
                        contentHeightPx,
                        "important"
                    );
                    modalBody.style.setProperty(
                        "max-height",
                        finalHeight + "px",
                        "important"
                    );
                    modalBody.style.setProperty(
                        "height",
                        finalHeight + "px",
                        "important"
                    );
                    modalBody.style.setProperty(
                        "min-height",
                        finalHeight + "px",
                        "important"
                    );
                    modalBody.offsetHeight;
                }, 150);
            };
            $scope.$watch("activeTab", function () {
                if (
                    $scope.activeTab === "resize" ||
                    $scope.activeTab === "ai" ||
                    $scope.activeTab === "lettering"
                ) {
                    $scope.calculateOptimalModalHeight();
                }
                if ($scope.activeTab === "lettering") {
                    normalizeLetteringSelectedSize();
                    updateLetteringPricing();
                }
            });

            $scope.$watch(
                function () {
                    return (
                        $scope.lettering && $scope.lettering.selectedSize
                    );
                },
                function () {
                    normalizeLetteringSelectedSize();
                    if ($scope.activeTab === "lettering") {
                        updateLetteringPricing();
                    }
                }
            );

            $scope.$watch(
                "letteringTextAreas",
                function () {
                    if (
                        $scope.activeTab === "lettering" &&
                        $scope.letteringMode.value === "add"
                    ) {
                        updateLetteringPricing();
                    }
                },
                true
            );
            $scope.$watch(
                "letteringReplacements",
                function () {
                    if (
                        $scope.activeTab === "lettering" &&
                        $scope.letteringMode.value === "replace"
                    ) {
                        updateLetteringPricing();
                    }
                },
                true
            );
            $scope.$watch(
                "letteringMode.value",
                function () {
                    if ($scope.activeTab === "lettering") {
                        updateLetteringPricing();
                    }
                }
            );
            window.addEventListener("resize", function () {
                if (
                    document.querySelector(".personalized-designs-modal-body")
                ) {
                    fixedModalHeightPx = null;
                    if (
                        $scope.activeTab === "resize" ||
                        $scope.activeTab === "ai" ||
                        $scope.activeTab === "lettering"
                    ) {
                        $scope.calculateOptimalModalHeight(true);
                    }
                }
            });
            $scope.$on("modal:opened", function (event, modalId) {
                if (modalId === "personalized-designs") {
                    $scope.price.regular = 0;
                    $scope.price.circle = 0;
                    $scope.letteringPriceFromApi = null;
                    setTimeout(function () {
                        fixedModalHeightPx = null;
                        $scope.calculateOptimalModalHeight(true);
                    }, 100);
                }
            });
        });
        //#endregion
    },
]);

